import * as PIXI from "pixi.js";
import { SoundManager } from "../../game/manager/SoundManager";
import { SpineManager } from "../../game/manager/SpineManager";
import { FileExtension } from "../file/FileType";
/*
 * ComponentUnloader.ts
 */
export class ComponentUnloader {
    constructor() {
        this.soundManager = SoundManager.getInstance();
    }
    unload(components) {
        for (let component of components) {
            this.unloadComponent(component);
        }
    }
    unloadComponent(component) {
        this.unloadTextures(component.getTextures());
        let filePaths = component.getFilePaths();
        for (let filePath of filePaths) {
            this.processFilePath(filePath);
        }
    }
    processFilePath(filePath) {
        if (filePath.isSpine()) {
            this.unloadSpine(filePath);
        }
        else if (filePath.isFont()) {
            this.unloadFont(filePath);
        }
        else if (filePath.isSound()) {
            this.unloadSound(filePath);
        }
    }
    unloadTextures(textures) {
        for (let texture of textures) {
            this.unloadTexture(texture);
        }
    }
    unloadSpine(filePath) {
        let texture = this.getSpineTexture(filePath);
        this.unloadTexture(texture);
        SpineManager.getInstance().remove(filePath.getUrl());
    }
    unloadFont(filePath) {
        let texture = this.getFontTexture(filePath);
        this.unloadTexture(texture);
    }
    unloadSound(filePath) {
        this.soundManager.unload(filePath);
    }
    unloadTexture(frame) {
        PIXI.Texture.removeFromCache(frame).destroy(true);
        PIXI.BaseTexture.removeFromCache(frame);
    }
    getSpineTexture(filePath) {
        const namePath = filePath.getUrl().replace(FileExtension.JSON, "");
        if (PIXI.utils.TextureCache[namePath + FileExtension.PNG]) {
            return namePath + FileExtension.PNG;
        }
        if (PIXI.utils.TextureCache[namePath + FileExtension.WEBP]) {
            return namePath + FileExtension.WEBP;
        }
        return null;
    }
    getFontTexture(filePath) {
        const namePath = filePath.getUrl().replace(FileExtension.XML, "");
        if (PIXI.utils.TextureCache[namePath + FileExtension.PNG]) {
            return namePath + FileExtension.PNG;
        }
        if (PIXI.utils.TextureCache[namePath + FileExtension.WEBP]) {
            return namePath + FileExtension.WEBP;
        }
        return null;
    }
}
//# sourceMappingURL=ComponentUnloader.js.map